import React from 'react';

const Menu = ({
  title,
  children,
  className,
  width = 'w-56',
  position = 'absolute',
  ...rest
}) => {
  const classNames = ['rounded bg-white shadow', position, width, className].join(
    ' '
  );

  return (
    <ul {...rest} className={classNames}>
      {title && <MenuItem>{title}</MenuItem>}
      {children}
    </ul>
  );
};

export function MenuItem({ children, className = '', onClick = () => {}, ...rest }) {
  return (
    <li
      {...rest}
      onClick={onClick}
      className={`menu-item px-4 py-4 block first:rounded-t last:rounded-b border-gray-900 bg-white hover:bg-gray-100 cursor-pointer ${className}`}
    >
      {children}
    </li>
  );
}

export default Menu;
